import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { adminLogin } from '@/lib/api'
import { getAdminToken, setAdminToken } from './AdminLayout'
import { PageMotion } from '@/components/Motion'
import { ErrorBlock } from '@/components/ui'

export default function AdminLogin() {
  const existing = getAdminToken()
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  if (existing) return <Navigate to="/admin" replace />

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await adminLogin(password)
      setAdminToken(res.token)
      navigate('/admin')
    } catch {
      setError('Invalid password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-canvas">
      <PageMotion className="w-full max-w-sm">
        <div className="panel p-6 sm:p-8">
          <div className="mb-6">
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-control border border-line bg-canvas-raised font-mono text-sm font-semibold text-accent">
              SL
            </div>
            <h1 className="page-title text-xl sm:text-2xl">Admin login</h1>
            <p className="page-subtitle">Enter the admin password to continue</p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="label">Password</label>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
            </div>
            {error ? <ErrorBlock message={error} /> : null}
            <button type="submit" className="btn-primary w-full" disabled={loading || !password}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </PageMotion>
    </div>
  )
}
